import { render, staticRenderFns } from "./customer-email.vue?vue&type=template&id=247ceda4&"
import script from "./customer-email.vue?vue&type=script&lang=js&"
export * from "./customer-email.vue?vue&type=script&lang=js&"
import style0 from "./customer-email.vue?vue&type=style&index=0&id=247ceda4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports